import moment from 'moment';

const maxDate = '2100-01-01';
const minDate = '1900-01-01';

const isDateValid = (date) => moment(date).isValid();

const isDateBefore = (date) => moment(date).isBefore(maxDate);
const isDateAfter = (date) => moment(date).isAfter(minDate);

const Helper = {
  isDateValid,
  isDateBefore,
  isDateAfter,
};

export default Helper;